import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ProfileHubSettingsDialogComponent } from '@main-client/src/app/profile/profile-hub-settings-dialog/profile-hub-settings-dialog.component';

import {
  Account,
  AccountGroupMembership,
} from '@libs/src/models/account.model';
import { Group } from '@libs/src/models/group.model';
import { Profile } from '@main-client/src/app/profile/profile';

@Injectable()
export class ProfileHubSettingsDialogService {
  constructor(private dialog: MatDialog) {}

  openDialog(data: {
    user: Account;
    profile: Profile;
    group: Group;
    membership: AccountGroupMembership;
    isIntroOnly: boolean;
  }) {
    return this.dialog.open(ProfileHubSettingsDialogComponent, {
      data,
      maxWidth: '600px',
      width: '95vw',
    });
  }
}
